var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 120,
    viewBox: "0 0 64 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3227 88.3437C63.3227 105.566 48.9074 120 31.6663 120C14.4253 120 0.0100098 105.585 0.0100098 88.3437C0.0100098 75.0167 8.67826 63.4081 17.3656 59.9905C8.69735 56.5728 0.0100098 44.9642 0.0100098 31.6372C0.0100098 14.4153 14.4253 0 31.6663 0C48.9074 0 63.3227 14.4153 63.3227 31.6372C63.3227 44.9642 54.6544 56.5537 45.9671 59.9905C54.6353 63.4081 63.3227 75.0167 63.3227 88.3437ZM31.5518 56.6874H31.6663C45.7188 54.2434 56.7164 45.6897 56.7164 31.6372C56.7164 17.5847 45.7188 6.47255 31.6663 6.47255C17.6138 6.47255 6.50164 17.5847 6.50164 31.6372C6.50164 45.6897 17.6138 56.6874 31.5518 56.6874ZM56.7164 88.3437C56.7164 74.2912 45.7188 63.2936 31.6663 63.2936H31.5518C17.6138 63.2936 6.50164 74.2912 6.50164 88.3437C6.50164 102.396 17.6138 113.508 31.6663 113.508C45.7188 113.508 56.7164 102.396 56.7164 88.3437Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber8);
export default __webpack_public_path__ + "static/media/NUMBER_8.ccc6e4afe073173bea41781d818a2c7a.svg";
export { ForwardRef as ReactComponent };